<div class="upload-files-modal">
  <div class="modal-header">
    <h3 class="modal-title">Upload files to Directory</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times"></i>
    </div>
  </div>
  <div class="modal-body" [hidden]="minimise">
    <div class="options">
      <div class="input-group">
        <span class="input-group-addon">/app/data/gtw/efile</span>
        <input type="text" class="form-control" [(ngModel)]="listPath">
      </div>
      <div class="row-2">
        <div class="file-picker-block">
          <input #fileInput
                 class="file-input-native"
                 type="file"
                 (change)="onFileSelected($event)"
                 multiple>
        </div>
        <button class="save-button upload-button"
                type="button"
                [disabled]="files.length === 0 || uploading"
                (click)="upload()">
          @if (uploading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Upload
        </button>
      </div>
    </div>
    <div class="w-100 mt-10">
      <label>List of existing Files:</label>
      @if (loadingFiles) {
<span><i class="fa fa-spinner fa-spin fa-2x"></i></span>
}
      @if (!loadingFiles) {
<ul class="existing-files-list">
        @if (listPath !== '') {
<li class="hyperlink" (click)="goBack()">...</li>
}
        @for (file of list; track $index) {
<li>
          <span [ngClass]="{'hyperlink': file.isFolder}" (click)="folderClicked(file)">{{ file.name }}</span>
          @if (!file.showConfirmation && !file.isDeleting) {
<i class="fa fa-trash color-red" (click)="file.showConfirmation = true"></i>
}
          @if (file.isDeleting) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
          @if (file.showConfirmation && !file.isDeleting) {
<span>
            <span class="color-red">(are you sure you want to delete the file/folder?)</span>
            <i class="fa fa-trash color-red" (click)="deleteFile(file)"></i>
            <i class="fa fa-remove" (click)="file.showConfirmation = false"></i>
          </span>
}
        </li>
}
      </ul>
}
    </div>
  </div>
</div>
